var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dsf-login-quick" }, [
    _c(
      "div",
      { staticClass: "login-box-info" },
      [
        _c("el-input", {
          attrs: {
            disabled: _vm.$attrs.loading,
            placeholder: _vm.$attrs.phonePlaceholder,
            size: "medium",
            "prefix-icon": "iconfont icon-icon_phone",
          },
          on: { input: _vm.handlePhone },
          model: {
            value: _vm.username,
            callback: function ($$v) {
              _vm.username = typeof $$v === "string" ? $$v.trim() : $$v
            },
            expression: "username",
          },
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPhoneMessage,
                expression: "showPhoneMessage",
              },
            ],
            staticStyle: {
              color: "red",
              "font-size": "13px",
              "margin-top": "5px",
            },
          },
          [_vm._v(" 请输入正确的手机号码 ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "login-box-phonecode" },
      [
        _c("el-input", {
          attrs: {
            disabled: _vm.$attrs.loading,
            placeholder: _vm.$attrs.passwordPlaceholder,
            size: "medium",
            "prefix-icon": "iconfont icon-yanzhengma1",
          },
          model: {
            value: _vm.smsCode,
            callback: function ($$v) {
              _vm.smsCode = typeof $$v === "string" ? $$v.trim() : $$v
            },
            expression: "smsCode",
          },
        }),
        _c(
          "div",
          {
            staticClass: "phone-code",
            class: { iscoding: _vm.timer },
            on: { click: _vm.handleGetCode },
          },
          [
            _c("span", { class: { "iscoding-click": _vm.codeClicking } }, [
              _vm._v(
                _vm._s(
                  _vm.dsf.isString(_vm.codeString)
                    ? _vm.codeString
                    : _vm.codeString + "s"
                ) + " "
              ),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm.$attrs.isShowCode
      ? _c(
          "div",
          { staticClass: "login-box-info login-code" },
          [
            _c("el-input", {
              attrs: {
                disabled: _vm.$attrs.loading,
                type: "text",
                placeholder: _vm.$attrs.codePlaceholder,
                size: "medium",
                "prefix-icon": "iconfont icon-yanzhengma1",
              },
              model: {
                value: _vm.code,
                callback: function ($$v) {
                  _vm.code = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "code",
              },
            }),
            _c("img", {
              staticClass: "img-code",
              attrs: { src: _vm.$attrs.codeUrl },
              on: {
                click: function ($event) {
                  return _vm.$emit("updateCodeUrl")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }